<template>
  <el-dialog
    title=""
    :visible.sync="this.$props.ShowImageCropper"
    :show-close="false"
    width="790px"
    class="ts-modal cropper"
    @close="onCloseDialog"
  >
    <button
      type="button"
      aria-label="Close"
      class="el-dialog__headerbtn"
      @click="onCloseDialog()"
    >
      <i class="el-dialog__close el-icon el-icon-close"></i>
    </button>

    <div style="overflow: hidden;">
      <p>Crop your image</p>
      <ImageCropper
        :src="imgToCrop"
        :bucketType="bucketType"
        :objectId="objectId"
        @onCloseDialog="onCloseDialog"
        @imageUploading="imageUploading"
      />
    </div>
  </el-dialog>
</template>

<script>
import ImageCropper from "../../components/ImageCropper";
export default {
  props: {
    ShowImageCropper: {
      type: Boolean,
      default: false
    },
    imgToCrop: "",
    bucketType: Number,
    objectId: {
      type: String,
      default: ""
    }
  },
  components: {
    ImageCropper
  },
  data() {
    return {
      data: {}
    };
  },
  methods: {
    onCloseDialog() {
      this.reset();
      this.$emit("close-cropper");
    },
    imageUploading(base64) {
      this.$emit("imageUploading", base64);
    },
    reset() {
      this.destination = {};
    }
  }
};
</script>

<style scoped></style>
